import { Link } from 'react-router-dom'
import { homeEcosystemCards } from '@/mocks/home'
import HomeIcon from './HomeIcon'
import { resetCardPointer, setCardPointer } from '../tilt'
import supplyIllustration from '@/assets/home/supply-platform.png'
import courseIllustration from '@/assets/home/learning-course.png'
import distributionIllustration from '@/assets/home/distribution.png'

const images = {
  supply: supplyIllustration,
  course: courseIllustration,
  distribution: distributionIllustration,
} as const

export default function EcosystemSection() {
  return (
    <section className="home-ecosystem home-screen">
      <div className="home-ecosystem__content">
        <div className="ecosystem-heading">
          <h2>灵搭，连接短剧的<span>三种可能</span></h2>
          <p>无论你是需求方、创作者还是发行方，灵搭岛都能帮你找到下一步</p>
        </div>
        <div className="ecosystem-grid">
          {homeEcosystemCards.map((card) => (
            <article
              key={card.title}
              className={`ecosystem-card ecosystem-card--${card.tone}`}
              onPointerMove={setCardPointer}
              onPointerLeave={resetCardPointer}
            >
              <img className="ecosystem-card__image" src={images[card.imageKey]} alt={card.title} />
              <div className="ecosystem-card__body">
                <div className="ecosystem-card__title">
                  <span className="ecosystem-card__icon"><HomeIcon name={card.icon} size={24} /></span>
                  <h3>{card.title}</h3>
                </div>
                <p>{card.description}</p>
                <div className="ecosystem-card__tags">
                  {card.tags.map((tag) => <span key={tag}>{tag}</span>)}
                </div>
                <div className="ecosystem-card__actions">
                  <Link to={card.to} className="ecosystem-card__primary">
                    {card.primary} <HomeIcon name="arrow-right" size={18} />
                  </Link>
                  {card.secondary && (
                    <Link to="/demands" className="ecosystem-card__secondary">
                      {card.secondary} <HomeIcon name="arrow-right" size={18} />
                    </Link>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
